module.exports = __webpack_public_path__ + "img/40_69_010_760.2d0296d4.jpg";